// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__D53CS","row":"ProcedureTreatmentSummary_row__3Nu9z"};